import React from "react";

const ChangePassword = (props) => {
  return <div className="change-container">change password</div>;
};

export default ChangePassword;
